<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card" shadow="hover">
          <div class="user">
            <el-avatar
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
              :size="130"
              class="user_img"
            >
              <!-- 当avatar中的链接访问不到时，展示img中图片 -->
              <img
                src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
              />
            </el-avatar>
            <div class="user_info">
              <p class="name">{{ userName }}</p>
              <p class="role">超级管理员</p>
            </div>
          </div>
          <div class="login_info">
            <p>上次登录时间：<span>2022-10-1</span></p>
            <p>上次登录地点：<span>北京</span></p>
          </div>
        </el-card>
        <el-card style="margin-top: 20px; height: 415px" shadow="hover">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(val, key) in tableLabel"
              :key="key"
              :prop="key"
              :label="val"
            >
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="16">
        <div class="num">
          <el-card
            v-for="item in countData"
            :key="item.name"
            :body-style="{
              display: 'flex',
              alignItems: 'center',
              padding: '0',
            }"
            shadow="hover"
          >
            <i
              class="icon"
              :class="`el-icon-${item.icon}`"
              :style="{ background: item.color }"
            ></i>
            <div class="detail">
              <p class="price">￥ {{ item.value }}</p>
              <p class="desc">{{ item.name }}</p>
            </div>
          </el-card>
        </div>

        <el-card style="height: 280px" shadow="hover">
          <div ref="echarts1" style="height: 280px">
            <!-- 折线图 -->
          </div>
        </el-card>

        <div class="graph">
          <el-card shadow="hover">
            <div ref="echarts2" style="height: 220px">
              <!-- 柱状图 -->
            </div>
          </el-card>
          <el-card shadow="hover">
            <div ref="echarts3" style="height: 175px">
              <!-- 饼状图 -->
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import * as echarts from "echarts";
import { mapState } from "vuex";
import Cookie from "js-cookie";
export default {
  name: "Home",
  data() {
    return {
      tableData: [],
      tableLabel: {
        name: "商品",
        todayBuy: "今日购买",
        monthBuy: "本月购买",
        totalBuy: "总购买",
      },
      countData: [
        {
          name: "今日支付订单",
          value: 0,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "今日收藏订单",
          value: 0,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "今日未支付订单",
          value: 0,
          icon: "s-goods",
          color: "#5ab1ef",
        },
        {
          name: "本月支付订单",
          value: 0,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "本月收藏订单",
          value: 0,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "本月未支付订单",
          value: 0,
          icon: "s-goods",
          color: "#5ab1ef",
        },
      ],
      userName:"",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.userName = Cookie.get("userName");
    // getData().then(({ data }) => {
    //   const { tableData } = data.data;
    //   this.tableData = tableData;

    //   //基于准备好的dom，初始化echarts实例
    //   //折线图
    //   const echarts1 = echarts.init(this.$refs.echarts1);
    //   var echarts1Option = {};
    //   //处理xAxis
    //   const { orderData, userData, videoData } = data.data;
    //   echarts1Option.xAxis = { data: orderData.date };
    //   const xAxis = Object.keys(orderData.data[0]);
    //   echarts1Option.legend = { data: xAxis };
    //   echarts1Option.yAxis = {};
    //   echarts1Option.tooltip = { trigger: "axis" };
    //   echarts1Option.series = [];
    //   xAxis.forEach((key) => {
    //     echarts1Option.series.push({
    //       name: key,
    //       data: orderData.data.map((item) => item[key]),
    //       type: "line",
    //     });
    //   });
    //   echarts1.setOption(echarts1Option);

    //   //柱状图
    //   const echarts2 = echarts.init(this.$refs.echarts2);
    //   var echarts2Option = {
    //     legend: {
    //       // 图例文字颜色
    //       textStyle: {
    //         color: "#333",
    //       },
    //     },
    //     grid: {
    //       left: "20%",
    //     },
    //     // 提示框
    //     tooltip: {
    //       trigger: "axis",
    //     },
    //     xAxis: {
    //       type: "category", // 类目轴
    //       data: userData.map((item) => item.date),
    //       axisLine: {
    //         lineStyle: {
    //           color: "#17b3a3",
    //         },
    //       },
    //       axisLabel: {
    //         interval: 0,
    //         color: "#333",
    //       },
    //     },
    //     yAxis: [
    //       {
    //         type: "value",
    //         axisLine: {
    //           lineStyle: {
    //             color: "#17b3a3",
    //           },
    //         },
    //       },
    //     ],
    //     color: ["#2ec7c9", "#b6a2de"],
    //     series: [
    //       {
    //         name: "新增用户",
    //         type: "bar",
    //         data: userData.map((item) => item.new),
    //       },
    //       {
    //         name: "活跃用户",
    //         type: "bar",
    //         data: userData.map((item) => item.active),
    //       },
    //     ],
    //   };
    //   echarts2.setOption(echarts2Option);

    //   //饼状图
    //   const echarts3 = echarts.init(this.$refs.echarts3);
    //   var echarts3Option = {
    //     tooltip: {
    //       trigger: "item",
    //     },
    //     color: [
    //       "#0f78f4",
    //       "#dd536b",
    //       "#9462e5",
    //       "#a6a6a6",
    //       "#e1bb22",
    //       "#39c362",
    //       "#3ed1cf",
    //     ],
    //     series: [
    //       {
    //         type: "pie",
    //         data: videoData,
    //       },
    //     ],
    //   };
    //   echarts3.setOption(echarts3Option);
    // });
  },
};
</script>

<style lang="less" scoped>
.user {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  .user_img {
    margin-right: 40px;
  }
  .user_info {
    .name {
      font-size: 32px;
      margin-bottom: 10px;
    }
    .role {
      color: #999999;
    }
  }
}
.login_info {
  p {
    line-height: 28px;
    font-size: 14px;
    color: #999;

    span {
      color: #666666;
      margin-left: 60px;
    }
  }
}

.num {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 30px;
    color: #fff;
    text-align: center;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 15px;

    .price {
      font-size: 22px;
      margin-bottom: 10px;
      line-height: 30px;
    }
    .desc {
      font-size: 13px;
      color: #999;
      text-align: center;
    }
  }

  .el-card {
    width: 32%;
    margin-bottom: 20px;
  }
}

.graph {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .el-card {
    width: 48%;
    height: 200px;
  }
}
</style>
